import { Autoplay, Navigation, Pagination, Swiper, Thumbs } from "swiper"
import { SliderItem } from './../types'
import VueTypes from 'vue-types'
import viewport from '~/mixins/viewport'
import staticId from '~/mixins/static-id'
import 'swiper/swiper.scss'

export default {
    mixins: [viewport, staticId],
    props: {
        slides: VueTypes.arrayOf(SliderItem).def([])
    },
    computed: {
        sliderClass() {
            return `-gallery-slider-${this.idStatic}`
        },
        sliderPaginationClass() {
            return `-gallery-slider-pagination-${this.idStatic}`
        },
    },
    data() {
        return {
            slider: null,
        }
    },
    watch: {
        isUnderOrEqualViewport768() {
            this.$nextTick(() => {
                this.initSwiper()
            })
        }
    },
    methods: {
        switchToNextSlide() {
            const swiperInstance = this.slider
            const currentIndex = swiperInstance.activeIndex
            const totalSlides = swiperInstance.slides.length
      
            if (currentIndex === (totalSlides - 1)) swiperInstance.slideTo(0) // Switch to first slide in case if is last
            else swiperInstance.slideNext()
        },
        initSwiper() {
            // !!! Use only on client side
            Swiper.use([Navigation, Pagination, Autoplay, Thumbs])

            this.slider = new Swiper(`.${this.sliderClass}`, {
                slidesPerView: 1,
                spaceBetween: 24,
                allowTouchMove: true,
                grabCursor: true,
                longSwipesRatio: 0.99,

                autoplay: {
                    delay: 1750,
                    disableOnInteraction: false
                },
                
                pagination: {
                    el: `.${this.sliderPaginationClass}`,
                    clickable: true,
                    
                    bulletClass: 'product-card__content__vizualization__slider__pagination__bullet',
                    bulletActiveClass: 'active',
                },
            })
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.initSwiper()
        })
    },
}